import React from 'react'
import {
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
} from '@chakra-ui/react';


export default function Card(props) {
  const { title, stat } = props;
  return (
    <Stat
      py={{ base: 5, md: 8 }}
      shadow={'md'}
      backgroundColor="white"
      borderColor={useColorModeValue('gray.800', 'gray.500')}
      rounded={'lg'}
      textAlign="center"
    >
      <StatLabel fontSize={'lg'} textColor={'#9FA2B4'} fontWeight={'semibold'}>
        {title}
      </StatLabel>
      <StatNumber fontSize={'4xl'} fontWeight={'bold'}>
        {stat}
      </StatNumber>
    </Stat>
  );
}
